import axios from "axios";
import auroraApi from "../../../api/aurora-api";

// This is the place where you connect to the backend which talks to carbon solutions...

const srecUrl = `https://dev.iondeveloper.com/api/proposal/carbon-solutions/carbon-solutions.php?api_key=${process.env.REACT_APP_API_KEY}`;
const apiUrl = `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`;

const listOfStates = require("us-state-converter");

export const createRecAcct = async (
  {
    projectID,
    name,
    street,
    city,
    state,
    zip,
    phone,
    email,
    latitude,
    longitude
  },
  mod,
  invType,
  invModel,
  systemSize,
  systemSizeAC,
  production,
  csUtilityId,
  setShowError,
  setErrorMessage
) => {
  const [firstName, lastName] = name.split(" ");

  try {
    const county = await getCounty(latitude, longitude);
    if (invType === "SolarEdge" && !invModel) {
      invType = "Solar Edge";
      const resAurora = await auroraApi.syncDesign({
        projectId: projectID,
      });
      
      if (resAurora.success) {
        const billOfMaterials =
          resAurora.aurora?.data?.design?.bill_of_materials ??
          resAurora.aurora?.data?.design?.bill_of_marerials;
        if (Array.isArray(billOfMaterials)) {
          billOfMaterials.forEach((material) => {
            if (material.component_type === "inverters") {
              invModel = material.name;
            }
          });
        }
      }
      if (!invModel) {
        invModel = "Solar Edge";
      }
    }
    let applicant = {
      state: listOfStates.abbr(state),
      name: `${firstName} ${lastName} - ${street}`,
      financing_type: "Finance",
      address: {
        street: street,
        street_2: "",
        city: city,
        zip: zip,
        state: listOfStates.abbr(state),
        county: county,
      },
      module: {
        make: `${mod[1]} Solar`,
        model: mod[2],
      },
      inverter: {
        make: invType,
        model: invModel,
        quantity: systemSize / mod[3],
      },
      meter: {
        make: "Enphase",
        model: "RGM",
      },
      installed_size_kw_ac: +systemSizeAC,
      installed_size_kw_dc: systemSize / 1000,
      est_first_year_production_kw_dc: production,
      est_first_year_production_support: "Aurora",
      system_build: "Planned",
      solar_arrays: [
        {
          quantity: systemSize / mod[3],
          wattage: mod[3],
          tilt: 18,
          orientation: 180,
          type: "Fixed - Roof Mount",
          bifacial: 0,
        },
      ],
      degredation: {
        year_1: 2,
        year_2_to_15: 0.3,
      },
      owner: {
        type: "Individual",
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone: phone.replace(/\D/g, ""),
        mailing_address: {
          street: street,
          street_2: "",
          city: city,
          zip: zip,
          state: listOfStates.abbr(state),
        },
      },
      utility_id: csUtilityId,
      installer_crm_id: projectID,
    };

    const res = await createCsAcct(applicant, setShowError, setErrorMessage);
    console.log(res, applicant);
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getCounty = async (lat, long) => {
  try {
    const res = await axios.get(
      `https://reportallusa.com/api/parcels/?client=zHcQ5DYoWC&si_srid=4326&spatial_intersect=POINT(${long} ${lat})&v=4`
    );
    console.log(res.data);
    return res.data.results[0].county_name;
  } catch (error) {
    console.error("Error occurred:", error);
    throw error;
  }
};

const createCsAcct = async (applicant, setShowError, setErrorMessage) => {
  try {
    const res = await axios.post(srecUrl, {
      method: "createAccount",
      applicant: JSON.stringify(applicant),
    });

    if (res.data.errors) {
      setShowError(true);
      setErrorMessage(`error creating SREC account - ${res.data.message}`);
      setTimeout(() => {
        setShowError(false);
        setErrorMessage("");
      }, 7500);
    } else {
      console.log(res.data);
      return res.data;
    }
  } catch (error) {
    console.error("Error occurred:", error);
    throw error;
  }
};
